import { InputLeftElement } from '@chakra-ui/react';

import { DisplayNames } from './enums';

InputLeftElement.displayName = DisplayNames.InputLeftElement;
export default InputLeftElement;
